import { notifyToaster } from '@assetron/web-common/components/Toaster/ToasterService';

interface ErrorMessages {
  [key: number]: string;
}

// Type guard to check if error has HTTP response with status code
const isHttpErrorResponse = (
  error: unknown,
): error is { response: { status: number } } => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof error.response === 'object' &&
    error.response !== null &&
    'status' in error.response &&
    typeof error.response.status === 'number'
  );
};

const apiErrorHandler = (
  error: unknown,
  errorMessages?: ErrorMessages,
  defaultErrorMessage?: string,
) => {
  // Early return if error is null or undefined
  if (!error) return;

  // Type guard to check if error has 'handled' property set to true
  if (
    typeof error === 'object' &&
    'handled' in error &&
    error.handled === true
  ) {
    return;
  }

  let errorMessage = defaultErrorMessage;
  const statusCode = isHttpErrorResponse(error)
    ? error.response.status
    : undefined;

  if (statusCode !== undefined && errorMessages?.[statusCode]) {
    errorMessage = errorMessages[statusCode];
  }

  // Only notify if we have an error message to display
  if (errorMessage) {
    notifyToaster({ type: 'error', message: errorMessage });
  }
};

export default apiErrorHandler;
